import { translate } from "app/filters/i18nFilter";
import { abbrNumberFilter } from "app/filters/ngFilters";
import { getRangeChipValue } from "app/pages/sales-intelligence/modules/find-apps-filters/utils";
import type { IAppsRatingFilter } from "app/pages/sales-intelligence/store/find-apps/types";
import { is } from "app/pages/sales-intelligence/utils/type-guards";

export const formatNumber = (value: number): string => abbrNumberFilter()(value) as string;

export const getNumberOfRatingChipText = (value: IAppsRatingFilter["numberOfRatings"]): string => {
    const { from, to } = value || {};

    const formattedFrom = is.undefined(from) ? "" : formatNumber(from);
    const formattedTo = is.undefined(to) ? "" : formatNumber(to);

    return `${translate("si.find_apps.filters.rating.select_rating.number.chip.label")}: ${getRangeChipValue({ from: formattedFrom, to: formattedTo }, false)}`;
};

interface GroupedNumbers {
    values: readonly number[];
    label: string;
}

export const groupNumbers = (
    numbers: readonly number[],
    formatLabel: (first: number, last: number) => string,
): GroupedNumbers[] => {
    if (numbers.length === 0) {
        return [];
    }

    const sortedNumbers = [...numbers].sort();

    const result: GroupedNumbers[] = [];
    let start = sortedNumbers[0];
    let group: number[] = [start];

    sortedNumbers.forEach((num, index) => {
        if (index === 0) {
            return;
        }

        if (num === sortedNumbers[index - 1] + 1) {
            group.push(num);
        } else {
            result.push({
                values: group,
                label: group.length > 1 ? formatLabel(start, group[group.length - 1]) : `${start}`,
            });
            start = num;
            group = [start];
        }
    });

    result.push({
        values: group,
        label: group.length > 1 ? formatLabel(start, group[group.length - 1]) : `${start}`,
    });

    return result;
};
